// src/components/StatsCard.tsx

import React from 'react';

interface StatsCardProps {
  title: string;
  value: number | string;
  icon: React.ReactElement;
  colorTheme: 'blue' | 'orange' | 'green' | 'red' | 'purple' | 'indigo';
}

const themeClasses = {
  blue: {
    gradient: 'from-blue-50 to-blue-100',
    border: 'border-blue-200',
    iconBg: 'bg-blue-500',
    valueText: 'text-blue-900',
    titleText: 'text-blue-700',
  },
  orange: {
    gradient: 'from-orange-50 to-orange-100',
    border: 'border-orange-200',
    iconBg: 'bg-orange-500',
    valueText: 'text-orange-900',
    titleText: 'text-orange-700',
  },
  green: {
    gradient: 'from-green-50 to-green-100',
    border: 'border-green-200',
    iconBg: 'bg-green-500',
    valueText: 'text-green-900',
    titleText: 'text-green-700',
  },
  red: {
    gradient: 'from-red-50 to-red-100',
    border: 'border-red-200',
    iconBg: 'bg-red-500',
    valueText: 'text-red-900',
    titleText: 'text-red-700',
  },
  purple: {
    gradient: 'from-purple-50 to-purple-100',
    border: 'border-purple-200',
    iconBg: 'bg-purple-500',
    valueText: 'text-purple-900',
    titleText: 'text-purple-700',
  },
  indigo: {
    gradient: 'from-indigo-50 to-indigo-100',
    border: 'border-indigo-200',
    iconBg: 'bg-indigo-500',
    valueText: 'text-indigo-900',
    titleText: 'text-indigo-700',
  },
};

export const StatsCard: React.FC<StatsCardProps> = ({ title, value, icon, colorTheme }) => {
  const theme = themeClasses[colorTheme];

  return (
    <div className={`bg-gradient-to-br ${theme.gradient} p-6 rounded-xl border ${theme.border} shadow-sm`}>
      <div className="flex items-center justify-between">
        <div className={`w-12 h-12 ${theme.iconBg} rounded-xl flex items-center justify-center shadow-lg`}>
          {icon}
        </div>
        <div className="text-right">
          <div className={`text-2xl font-bold ${theme.valueText} mb-1`}>{value}</div>
          <div className={`text-sm ${theme.titleText}`}>{title}</div>
        </div>
      </div>
    </div>
  );
};